import React from 'react';
import { Loading, ProgressBar, Table, TBody, TD, TH, THead, TR } from '@sede-enterprise/shell-ds-react-framework';
import { siteMapping } from '../../util/helperFunctions';
import useUserData from './hooks/useUserData';

import * as R from "rambda";

const UserData = ({ selectedSite, startDate, endDate }) => {

    const { userPageData, loading } = useUserData(selectedSite, startDate, endDate);

    const cells = [
        {
            id: "user",
            align: "left",
            label: "User",
            content: (row) =>
                siteMapping(R.path(
                    ["user"],
                    row
                )),
        },
        {
            id: "page",
            align: "right",
            label: "Pages",
            info: 'No. of pages viewed by User',
            content: (row) =>
                R.path(["page"], row),
        },
        {
            id: "views",
            align: "right",
            label: "Views",
            info: 'Total views by user to (Pages)',
            content: (row) =>
                R.path(["views"], row),
        },
        {
            id: "views%",
            align: "left",
            label: "Views %",
            info: '(views/sum of views of all users)* 100',
            content: (row) =>
                <ProgressBar value={R.path(["viewsPrecentage"], row)} label size='small' type='line' />
        },
    ];


    return loading ? <div className='loading-container' role='status'><Loading /></div> : userPageData?.length > 0 ?
        <div className='user-data-container'>
            <Table className='basic-table' style={{ width: "100%" }}>
                <THead style={{ background: "rgb(245, 245, 245)" }}>
                    <TR>
                        <TH>User</TH>
                        <TH>Pages</TH>
                        <TH>Views</TH>
                        <TH>Views %</TH>
                    </TR>
                </THead>
                <TBody>
                    {userPageData?.map((row) =>
                        <TR key={row.id}>
                            {cells.map(cell => (<TD component="th" scope="row" key={cell.id}>
                                {cell.content(row)}
                            </TD>
                            ))}
                        </TR>
                    )}
                </TBody>
            </Table>
        </div>
        : <p className='data-value'>No Data Available</p>
}

export default UserData